module.exports = __webpack_public_path__ + "3d6ede59bdbd6510d9cf031386aa4103.png";